<template>
  <div class="relative flex items-center">
    <div class="flex items-center h-5">
      <input
        :id="getId"
        aria-describedby="comments-description"
        :name="name"
        @change="handlerInput"
        type="checkbox"
        :checked="value"
        :class="cssClass"
        :disabled="disabled"
      />
    </div>
    <div class="ml-3 text-sm">
      <label :for="getId" class="font-medium" :class="isDisabled">{{
        label
      }}</label>
      <p id="comments-description" class="text-gray-500" v-if="description">
        {{ description }}
      </p>
    </div>
  </div>
</template>
<script>
export default {
  name: "CheckBox",

  emits: ["update:modelValue"],

  props: {
    modelValue: {
      default: false,
      type: Boolean,
      required: false,
    },
    name: {
      default: "",
      type: String,
      required: false,
    },
    description: {
      default: "",
      type: String,
      required: false,
    },
    label: {
      default: "",
      type: String,
      required: false,
    },
    classes: {
      default: "",
      type: String,
      required: false,
    },
    id: {
      default: "",
      type: String,
      required: false,
    },
    event: {
      default: "",
      type: String,
      required: false,
    },
    callback: {
      default: null,
      type: Function,
      required: false,
    },
    disabled: {
      default: false,
      type: Boolean,
      required: false,
    },
    data: {
      default: () => {},
      type: Object,
      required: false,
      description: "to use with callback function",
    },
    rule: {
      default: () => {},
      type: Object,
      required: false,
      description: "for validation rule",
    },
    check: {
      default: "",
      type: [Number, String, Array],
      required: false,
      description: "to trigger validation method",
    }
  },

  data() {
    return {
      value: false,
    };
  },

  watch: {
    modelValue: {
      handler(value) {

      let currentBool = value;
        if(typeof value != 'boolean') {
          currentBool = value == this.id;
        }

        if(currentBool != this.value) {
          this.value = currentBool;
        this.manipulateToEmit();
        }

      },
    }
  },

  computed: {
    cssClass() {
      let className = []

      if (this.disabled) {
        className.push("h-4 w-4 text-[#F7C29B] border-gray-300 rounded");
      } else {
        className.push([
          "focus:ring-[#ff7e32] h-4 w-4 text-[#ff7e32] border-[#F7C29B] rounded cursor-pointer checked:bg-[#ff7e32] checked:border-[#ff7e32]",
        ]);
      }

      className.push(this.classes);

      return className;
    },
    getId() {
      return this.id ? this.id : this.makeId(4);
    },
    isDisabled() {
      return this.disabled ? "text-gray-500" : "text-gray-700 cursor-pointer";
    }
  },

  mounted() {
    this.value = this.modelValue;
    this.manipulateToEmit(this.modelValue);
  },

  methods: {
    makeId(length) {
      var result = "";
      var characters =
        "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
      var charactersLength = characters.length;
      for (var i = 0; i < length; i++) {
        result += characters.charAt(
          Math.floor(Math.random() * charactersLength)
        );
      }
      return result;
    },
    handlerInput(e) {
      this.value = e.target.checked;

      this.manipulateToEmit();
    },
    manipulateToEmit() {

      let boolValue = this.value;

      let emitValue = this.$attrs.modelValue
        ? this.$attrs.modelValue
        : this.modelValue;

      if (Array.isArray(this.modelValue)) {
        if (boolValue) {
          emitValue.push(this.$attrs.value);
        } else {
          emitValue = emitValue.filter((v) => v != this.$attrs.value);
        }
      } else {
        emitValue = boolValue;
      }

      this.emit(emitValue);
    },
    emit(value) {
      this.$emit("update:modelValue", value);

      if (this.callback) {
        this.callback(value, this.data);
      }
    },
    validate() {},
  },
};
</script>